import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import { useToast } from '../context/ToastContext.jsx'
import ConfigNotice from '../components/ConfigNotice.jsx'
import Seo from '../components/Seo.jsx'

export default function ForgotPassword() {
  const { requestPasswordReset, isConfigured } = useAuth()
  const toast = useToast()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    const res = await requestPasswordReset(email)
    setBusy(false)
    if (res.error) return setError(res.error)
    setSent(true)
    toast('Reset link sent', 'green')
  }

  return (
    <main className="page">
      <Seo title="Reset your password | CalculateMyPeptides" noindex />
      <div className="container auth-wrap">
        <div className="card auth-card fade-in">
          <div className="auth-head">
            <h1>Reset your password</h1>
            <p>Enter your email and we’ll send a link to set a new password.</p>
          </div>
          {!isConfigured && <ConfigNotice />}
          {sent ? (
            <div className="ok-notice">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. Check your
              inbox (and spam), then follow the link to choose a new password.
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="field">
                <label className="label">Email</label>
                <input className="input" type="email" autoComplete="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
              </div>
              {error && <div className="form-error" style={{ marginBottom: 12 }}>{error}</div>}
              <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
          )}
          <div className="auth-foot">
            Remembered it? <Link to="/login">Back to log in</Link>
          </div>
        </div>
      </div>
    </main>
  )
}
